namespace Gamification.Gamification {
    export interface DispositiviRow {
        IdDispositivo?: number;
        UserId?: number;
        Nome?: string;
        Descrizione?: string;
        Note?: string;
    }

    export namespace DispositiviRow {
        export const idProperty = 'IdDispositivo';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Dispositivi';
        export const lookupKey = 'Gamification.Dispositivi';

        export function getLookup(): Q.Lookup<DispositiviRow> {
            return Q.getLookup<DispositiviRow>('Gamification.Dispositivi');
        }
        export const deletePermission = 'Role:SuperAdmin';
        export const insertPermission = 'Role:SuperAdmin';
        export const readPermission = 'Gamification:Configurazione:View';
        export const updatePermission = 'Role:SuperAdmin';

        export declare const enum Fields {
            IdDispositivo = "IdDispositivo",
            UserId = "UserId",
            Nome = "Nome",
            Descrizione = "Descrizione",
            Note = "Note"
        }
    }
}
